import React, { useState } from 'react';
import { size } from 'lodash';
import JoinOurTeamStatement from 'components/molecules/joinOurTeamStatement';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { PaginationControl } from 'components/molecules/paginationControl';
import { useViewport } from 'components/templates/viewportProvider';
import { CallToAction } from 'components/atoms/callToAction';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';
import './styles.scss';

const JoinOurTeam = props => {
  const { height } = useViewport();
  const [sliderRef, setSlider] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const [showRoles, setShowRoles] = useState(false);

  const jobs = props.data && props.data.data.jobPosts;
  const { showButton } = props.data && props.data.data;
  const length = size(jobs);

  const handleSliderRef = ref => {
    setSlider(ref);
  };

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };

  const showOverlay = showRoles ? (
    <OverlayPortal>
      <OverlayModal
        data={jobs}
        theme={'dark-theme'}
        type={'view-all-roles'}
        onClosePress={() => setShowRoles(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'About',
            breadcrumbLink: RouteNames.about,
          },
          {
            breadcrumbName: 'All Roles',
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  const className = 'join-our-team-container section-container';
  return (
    <div className={className} style={{ height }}>
      <JoinOurTeamStatement onClick={setShowRoles} showButton={showButton} />
      <div className={'carousel'}>
        <HorizontalCarousel
          type={'join-our-team'}
          data={jobs}
          getActiveSlide={e => {
            setActiveSlide(e);
          }}
          handleSliderRef={handleSliderRef}
        />
      </div>
      <div className={'section-footer show-explore'}>
        <PaginationControl
          className={'section-footer-item'}
          theme={'dark-theme'}
          mode={'slider'}
          currentIndex={activeSlide + 1}
          total={length}
          onNextClick={next}
          onPreviousClick={previous}
          key={'17'}
        />
      </div>
      {showOverlay}
    </div>
  );
};

export default JoinOurTeam;
